import React, { useState } from "react";
import { Row, Card, Col, ListGroup, Navbar } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Profile from "./Profile";
import MyOrders from "./MyOrders";
import CreateOrder from "./CreateOrder";
import Earnings from "./Earnings";
import MyTransactions from "./MyTransactions";

const Dashboard = () => {
  const [tabPanelIndex, setTabPanelIndex] = useState(0);

  return (
    <Row>
      <Col xs={6} md={3} lg={2}>
        <Card style={{ width: "150%" }}>
          <Card.Header>
            <h7>Menu</h7>
          </Card.Header>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <LinkContainer to="/dashboard">
                <Navbar.Brand onClick={() => setTabPanelIndex(0)}>
                  <h6> Profile</h6>
                </Navbar.Brand>
              </LinkContainer>
            </ListGroup.Item>
            <ListGroup.Item>
              <LinkContainer to="/dashboard">
                <Navbar.Brand onClick={() => setTabPanelIndex(1)}>
                  <h6> MyTransactions </h6>
                </Navbar.Brand>
              </LinkContainer>
            </ListGroup.Item>
            {/* <ListGroup.Item>
              <LinkContainer to="/dashboard">
                <Navbar.Brand onClick={() => setTabPanelIndex(1)}>
                  <h6>Create Order</h6>
                </Navbar.Brand>
              </LinkContainer>
            </ListGroup.Item>
            <ListGroup.Item>
              <LinkContainer to="/dashboard">
                <Navbar.Brand onClick={() => setTabPanelIndex(2)}>
                  <h6> My Orders </h6>
                </Navbar.Brand>
              </LinkContainer>
            </ListGroup.Item>
            <ListGroup.Item>
              <LinkContainer to="/dashboard">
                <Navbar.Brand onClick={() => setTabPanelIndex(3)}>
                  <h6> Earnings </h6>
                </Navbar.Brand>
              </LinkContainer>
            </ListGroup.Item> */}
          </ListGroup>
        </Card>
      </Col>
      <Col lg={1} />
      <Col xs={12} md={9} lg={9}>
        {tabPanelIndex === 0 && <Profile />}
        {tabPanelIndex === 1 && <MyTransactions />}
        {/* {tabPanelIndex === 1 && <CreateOrder />} */}
        {/* {tabPanelIndex === 2 && <MyOrders />} */}
        {/* {tabPanelIndex === 3 && <Earnings />} */}
      </Col>
    </Row>
  );
};

export default Dashboard;
